import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { serviceUris } from '../../../../environments/services';
import { Injectable, inject } from '@angular/core';
import { BackOfficeAuditFilter } from '../models/bo-audit-filter.model';
import { BackOfficeAuditTrail } from '../models/backOfficeAuditTrail.model';
import { PaginatedBoAuditResponse } from '../models/paginated-bo-audit.model';

export interface ActionListResponse {
  data: Array<string>;
  error: Array<string>;
}

export interface BoAuditExportResponse {
  data: {
    boAuditTrail: BackOfficeAuditTrail[];
  };
  error: Array<string>;
}

@Injectable({
  providedIn: 'root'
})
export class BoAuditService {
  private http = inject(HttpClient);

  /**
   * back office audit trail
   * @param filters
   * @param pageNumber
   * @param pageSize
   */
  searchBoAudit(
    filters: BackOfficeAuditFilter,
    pageNumber: number,
    pageSize: number,
    localTimeZone: string
  ): Observable<PaginatedBoAuditResponse> {
    const filteredParams = Object.entries(filters).reduce((acc, [key, value]) => {
      if (value != null && value !== '') {
        acc[key] = value;
      }
      return acc;
    }, {} as any);

    const params: any = {
      ...filteredParams,
      page: pageNumber,
      pageSize
    };
    const url = `${environment.backOfficeUrl}${serviceUris.searchBoAuditList}`;
    return this.http.get<PaginatedBoAuditResponse>(url, { headers: { localTimeZone }, params: params });
  }

  searchBoAuditExport(filters: BackOfficeAuditFilter, localTimeZone: string): Observable<BoAuditExportResponse> {
    const filteredParams = Object.entries(filters).reduce((acc, [key, value]) => {
      if (value != null && value !== '') {
        acc[key] = value;
      }
      return acc;
    }, {} as any);

    const url = `${environment.backOfficeUrl}${serviceUris.searchBoAuditExportList}`;
    return this.http.get<BoAuditExportResponse>(url, { headers: { localTimeZone }, params: filteredParams });
  }
}
